import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, X } from 'lucide-react';
import { tools } from '../../data/tools';
import './SearchBar.css';

const SearchBar = () => {
    const [query, setQuery] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const searchRef = useRef(null);

    // Filter tools based on search query
    const filteredTools = query.trim()
        ? tools.filter(tool =>
            tool.title.toLowerCase().includes(query.toLowerCase()) ||
            tool.description.toLowerCase().includes(query.toLowerCase())
        )
        : [];

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleInputChange = (e) => {
        setQuery(e.target.value);
        setIsOpen(true);
    };

    const handleToolClick = (path) => {
        navigate(path);
        setQuery('');
        setIsOpen(false);
    };

    const handleClear = () => {
        setQuery('');
        setIsOpen(false);
    };

    return (
        <div className="search-bar" ref={searchRef}>
            <div className="search-input-wrapper">
                <Search className="search-icon" size={18} />
                <input
                    type="text"
                    className="search-input"
                    placeholder="Search tools..."
                    value={query}
                    onChange={handleInputChange}
                    onFocus={() => query && setIsOpen(true)}
                />
                {query && (
                    <button className="search-clear" onClick={handleClear} aria-label="Clear search">
                        <X size={18} />
                    </button>
                )}
            </div>

            {isOpen && filteredTools.length > 0 && (
                <div className="search-results">
                    {filteredTools.map((tool) => (
                        <div
                            key={tool.id}
                            className="search-result-item"
                            onClick={() => handleToolClick(tool.path)}
                        >
                            <div className="search-result-icon" style={{ backgroundColor: tool.color }}>
                                <tool.icon size={18} color="white" />
                            </div>
                            <div className="search-result-content">
                                <div className="search-result-title">{tool.title}</div>
                                <div className="search-result-description">{tool.description}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {isOpen && query && filteredTools.length === 0 && (
                <div className="search-results">
                    <div className="search-no-results">No tools found</div>
                </div>
            )}
        </div>
    );
};

export default SearchBar;
